export default "__VITE_ASSET__B3QYRYDw__"